export class BaseCacheSettings {
  public ignoreCache = false; // by default cache is enabled
  public cacheExpiresInSeconds: number;
}
